import React from "react";
import { Grid } from "@mui/material";
import styles from "./hero.module.scss";
import { getAssets } from "@unisearch/helpers";
import { vPopup } from "@_recoil/_state";
import { useRecoilValue } from "recoil";

export const VOfficeHero = () => {
  const { handleVPopup } = useRecoilValue(vPopup);
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={{ xs: 2, sm: 2, md: 4 }} alignItems="center">
          <Grid item xs={12} sm={12} md={6}>
            <h1 className={styles.title}>
              <span className={styles.font_thin}>Can’t come see us?</span>
              <br />
              The next best thing - visit us virtually!
            </h1>
            <button
              onClick={handleVPopup}
              className={`${styles.btn_wrapper} btn btn-secondary btn-bg`}
            >
              Book an Appointment
            </button>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/voffice/hero-image-voffice.png")}
                alt="Unisearch Virtual Office"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default VOfficeHero;
